export default __webpack_public_path__ + "static/media/36_photo.ab0be7b2.jpg";